import { Checkbox } from "@mui/material"
import { useSimilaritySelection } from "../similarity-selection-context"

export function SelectAllSimilarityResults({ ...props }) {
    const { allMatching, excludedTasks, availableCount, selectedCount, selectAllMatching, clearSelection } =
        useSimilaritySelection()
    const allChecked = allMatching && Object.keys(excludedTasks).length === 0

    return (
        <Checkbox
            indeterminate={selectedCount > 0 && !allChecked}
            checked={allChecked}
            disabled={availableCount === 0}
            onChange={({ target }) => (target.checked ? selectAllMatching() : clearSelection())}
            {...props}
        />
    )
}
